module.exports = __webpack_public_path__ + "static/img/aboutUs16.d19adb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/aboutUs16.jpg
// module id = 1368
// module chunks = 1